import { defineStore } from 'pinia';

/** 存储预警信号*/
export const warningSignalStore = defineStore({
  id: 'warningSignal', // id必填
  state: () => {
    return {
      Target: []
    }
  }
})